import { Routes, Route, useLocation } from 'react-router-dom'
import { useWebAuthBootstrap } from './AppBootstrap'
import { useAppStore } from '@/store/useAppStore'
import {
  useCategories,
  useCards,
  useFavorites,
  useAnnouncements,
  useSubscription,
} from '@/hooks/useApi'
import LoadingScreen from '@/components/LoadingScreen/LoadingScreen'
import ScrollToTop from '@/components/ScrollToTop'
import Layout from '@/components/Layout/Layout'
import HomePage from '@/pages/HomePage/HomePage'
import ProfilePage from '@/pages/ProfilePage/ProfilePage'
import CardPage from '@/pages/CardPage'
import SubscribePage from '@/pages/SubscribePage'
import CoursesPage from '@/pages/CoursesPage/CoursesPage'
import CourseDetailPage from '@/pages/CourseDetailPage/CourseDetailPage'
import LessonPage from '@/pages/LessonPage/LessonPage'
import FavoritesPage from '@/pages/FavoritesPage/FavoritesPage'
import CalculatorPage from '@/pages/CalculatorPage/CalculatorPage'
import AuthPage from '@pages/AuthPage/AuthPage'
import TermsPage from '@pages/TermsPage/TermsPage'
import PrivacyPage from '@pages/PrivacyPage/PrivacyPage'
import { ROUTES, WEDDING_COURSE_ID } from '@shared/config/routes'
import { LinkTelegramConfirmScreen } from '@features/link-telegram/ui/LinkTelegramConfirmScreen'
import { PaymentStatusModal } from '@features/payments'
import AuthDebugPanel from '@/components/AuthDebugPanel/AuthDebugPanel'
import { ProtectedRoute } from './routes/ProtectedRoute'
import { PublicRoute } from './routes/PublicRoute'
import { WebBackButton } from '@/components/WebBackButton/WebBackButton'

export const WebAppShell = () => {
  const { status } = useWebAuthBootstrap()
  const location = useLocation()
  const authStatus = useAppStore(s => s.authStatus)
  const isAuthComplete = authStatus === 'success'

  // Легаси-хуки стреляют после установки authStatus=success в AppBootstrap.
  useCategories(isAuthComplete)
  useCards()
  useFavorites()
  useAnnouncements()
  useSubscription()

  if (status === 'pending') {
    return <LoadingScreen isLoading={true} />
  }

  const shouldApplySafeArea =
    !location.pathname.startsWith('/card/') &&
    !location.pathname.startsWith('/subscribe') &&
    !location.pathname.match(/^\/courses\/\d/) &&
    !location.pathname.startsWith('/wc') &&
    !location.pathname.startsWith('/auth')

  return (
    <div className={shouldApplySafeArea ? 'safe-area-inset' : ''}>
      <ScrollToTop />
      <WebBackButton />
      <Routes>
        <Route
          path="auth"
          element={
            <PublicRoute>
              <AuthPage />
            </PublicRoute>
          }
        />
        <Route path="terms" element={<TermsPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route
          path="wc"
          element={
            <CourseDetailPage
              courseId={WEDDING_COURSE_ID}
              buyRedirectPath={ROUTES.WC}
            />
          }
        />
        <Route
          path="link-telegram/confirm"
          element={<LinkTelegramConfirmScreen />}
        />

        <Route element={<ProtectedRoute />}>
          <Route path="card/:cardId" element={<CardPage />} />
          <Route path="courses/:courseId" element={<CourseDetailPage />} />
          <Route
            path="courses/:courseId/lesson/:lessonId"
            element={<LessonPage />}
          />
          <Route path="subscribe" element={<SubscribePage />} />
          <Route path="calculator/:cardId?" element={<CalculatorPage />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="courses" element={<CoursesPage />} />
            <Route path="favorites" element={<FavoritesPage />} />
          </Route>
        </Route>
      </Routes>
      <PaymentStatusModal />
      {/* <AuthDebugPanel /> */}
    </div>
  )
}
